import React from 'react';
import { Empty, Table } from 'antd';
import Skeleton from '@mui/material/Skeleton';

/**
 * @typedef {object} StyledTableOwnProps
 * @property {boolean} loading
 * @property {Array<*>} [dataSource]
 * @property {string} [skeletonHeight]
 * @property {'auto'} [overflowX]
 * @property {string | ((record: *) => string)} [rowClassName]
 * @property {string | ((record: *) => string)} [rowKey]
 */

/**
 * @typedef {StyledTableOwnProps & React.ComponentProps<typeof Table>} StyledTableProps
 */

/**
 * @param {StyledTableProps} props
 */
const StyledTable = props => {
  const { loading, skeletonHeight = '25vh', dataSource, ...otherProps } = props;

  const dataSourceInternal = loading ? [] : dataSource;

  return (
    <Table
      {...otherProps}
      dataSource={dataSourceInternal}
      locale={{
        emptyText: loading ? (
          <Skeleton animation='wave' variant='rectangular' height={skeletonHeight} width='100%' />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }}
    />
  );
};

export default StyledTable;
